import React from 'react';
import './premiumamenities.scss'
import { MdOutlineSecurity } from "react-icons/md";
import { MdOutlineChair } from "react-icons/md";
import { PiParkBold } from "react-icons/pi";
import { MdOutlineSoupKitchen } from "react-icons/md";
import { MdOutlineBed } from "react-icons/md";
import { FaWater } from "react-icons/fa";
import { MdOutlineBatteryChargingFull } from "react-icons/md";

const PremiumAmenities = () => {
	return (
		<>
			<section className="PremiumAmenities-amenities">
				<h2>Amenities</h2>

				<div className="PremiumAmenities-amenities-grid">
					<div className="PremiumAmenities-amenity-item">
						<div className="icon-wrap"><MdOutlineSecurity /></div>
						Safe & Secure Stay
					</div>
					
					<div className="PremiumAmenities-amenity-item">
						<div className="icon-wrap"><MdOutlineChair /></div>
						Fully Furnished
					</div>
					
					<div className="PremiumAmenities-amenity-item">
						<div className="icon-wrap"><PiParkBold /></div>
						Parking Available
					</div>
					
					<div className="PremiumAmenities-amenity-item">
						<div className="icon-wrap"><MdOutlineSoupKitchen /></div>
						Kitchen Access
					</div>
					
					<div className="PremiumAmenities-amenity-item">
						<div className="icon-wrap"><MdOutlineBed /></div>
						Extra Beds Available
					</div>
					
					<div className="PremiumAmenities-amenity-item">
						<div className="icon-wrap"><FaWater /></div>
						RO & 24 Hour Water
					</div>
					
					<div className="PremiumAmenities-amenity-item">
						<div className="icon-wrap"><MdOutlineBatteryChargingFull /></div>
						Inverter Backup
					</div>
				</div>
			</section>
		</>
	);
};

export default PremiumAmenities;